<template>
  <div id="wrapper" :class="pageType">
    <div id="bgr"></div>
    <transition name="fade">
      <div class="loader la-timer" v-if="!componentLoaded">
        <div></div>
      </div>
    </transition>
    <div id="app">
      <div id="logo">
        <a href="/">
          <img alt="WDR4 Lieblingsticket Logo" src="./assets/wdr4-tickets.svg"/>
        </a>
      </div>
      <div id="introduction">
        Hier finden Sie alle Veranstaltungen, die WDR 4 veranstaltet oder präsentiert.<br/>
        Suchen Sie in den einzelnen Rubriken oder ganz individuell mit Ihrem Suchbegriff. Viel Spaß!  
      </div>
      <transition name="fade" mode="out-in">
        <router-view @loaded="isComponentLoaded" :key="$route.name"></router-view>
      </transition>
    </div>

    <div id="footer">
      <ul>
        <li>
          <router-link to="/agb">AGB</router-link>
        </li>
        <li>
          <router-link to="/impressum">Impressum</router-link>
        </li>
        <li>
          <router-link to="/datenschutz">Datenschutz</router-link>
        </li>
      </ul>
      <p>
        <small>&copy; WDR mediagroup GmbH {{ date }}</small>
      </p>
    </div>

  </div>
</template>

<script>

export default {
  name: "App",
  created() {
    this.$router.beforeEach((to, from, next) => {
      if( to.query.suche && from.query.suche !== to.query.suche ){
        this.isComponentLoaded('start');
        this.$router.go();
      }
      else {
        this.componentLoaded = false;
      }
      next();
    });
  },
  data() {
    return {
      componentLoaded: false,
      pageType: "start",
      date: new Date().getFullYear()
    };
  },
  methods: {
    isComponentLoaded(pageType) {
      this.componentLoaded = true;
      this.pageType = pageType;
    }
  }
};
</script>

<style>

@import "./assets/timer.min.css";

@font-face {
    font-family: Thesis;
    src: url(assets/TheSans_LT_TT5_.eot#);
    src: url(assets/TheSans_LT_TT5_.woff) format('woff'),url(assets/TheSans_LT_TT5_.svg) format('svg');
    font-weight: 400;
    font-style: normal
}

@font-face {
    font-family: Thesis;
    src: url(assets/TheSans_LT_TT7_.eot#);
    src: url(assets/TheSans_LT_TT7_.woff) format('woff'),url(assets/TheSans_LT_TT7_.svg) format('svg');
    font-weight: 700;
    font-style: normal
}

@font-face {
    font-family: Thesis;
    src: url(assets/TheSans_LT_TT5i.eot#);
    src: url(assets/TheSans_LT_TT5i.woff) format('woff'),url(assets/TheSans_LT_TT5i.svg) format('svg');
    font-weight: 400;
    font-style: italic
}

button {
  cursor: pointer;
}

#wrapper, button, input {
  font-family: Thesis, Arial, Helvetica, sans-serif !important;
}

#bgr {
  background-image: url(./assets/hg-wdr-vier-100__v-HintergrundXL.jpg);
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  position: fixed
}

#logo {
  text-align: left;
  margin-left: .75rem
}
#logo img {
  width: 220px
}

#introduction {
  color: #474747;
  padding: 1rem .8334rem 0
}

#app {
  font-size: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 2rem 1rem 10rem;
  position: relative;
  box-sizing: border-box
}

#app .container,
#app .page {
  padding-bottom: 3rem;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
}

#app .container {
  padding-bottom: 1rem
}

#app .list {
  margin-top: 0
}

#app .list a {
  border-bottom: 1px solid rgba(0, 0, 0 ,0);
  transition: border-bottom 500ms;
}
#app .list a:hover,
#app .list a:focus {
  border-bottom: 1px solid rgba(0, 0, 0, 1);
}

#app .page {
  padding: 1rem;
  margin-top: 1rem
}


#app .filter {
  padding-top: 1rem;
  margin: 1.5rem 0 1rem;
  text-align: center;
}

#app .list p span.location img {
  height: 20px
}

#app .search {
  right: 1rem;
  top: -8.1334rem;
}

#app .searchField {
  background-color: transparent
}

#footer {
  margin: 0;
  background-color: #fff;
  padding: 2rem;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
}
#footer ul li a,
#footer p {
  color: #000;
}
#footer ul {
  list-style: none;
  display: inline-block;
  margin: 0;
  padding: 0
}
#footer li {
  display: inline-block;
  margin: 0 1rem;
}
#footer a {
  text-decoration: none;
}
#footer p {
  display: inline-block;
  float: right;
  margin: 0;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(244,160,24, 0.8);
  z-index: 99999;
  color: #000;
}

.loader > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) scale(3)
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-slow-enter-active,
.fade-slow-leave-active {
  transition: opacity 1.5s;
}
.fade-slow-enter, .fade-slow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (max-width: 640px) {
  #app {
    padding: 1.5rem 1.5rem 10rem;
  }
  #introduction {
    display: none
  }
  #logo {
    margin-left: .3334rem
  }
  #logo img {
    width: 180px;
    margin-left: .5rem
  }
  #app .search .mobile-toggle {
    top: -4.5rem;
    right: 0;
  }
  #app .filter {
    margin-top: 1rem;
    margin-bottom: 1rem
  }
  #footer {
    text-align: center;
    position: relative
  }
  #footer ul,
  #footer p {
    display: block;
    float: none;
  }
  #footer p {
    margin-top: 2rem;
  }
}
@media screen and (max-width: 699px) {
  #app .search {
    top: -10.5rem;
  }
}
</style>